import CRUD from './genericCRUD'

const route = 'phases'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function phase(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {string} phaseName
		 * @param { string } farmName
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			phaseName,
			farmName,
			pageNumber,
			pageSize,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const phaseParam = phaseName ? `phaseName=${phaseName}&` : ''
			const farmParam = farmName ? `farmName=${farmName}&` : ''

			return instance.get(`${route}?${params}${phaseParam}${farmParam}`, config)
		}
	}
}
